import type { IconGlyph } from '@sunwebgroup/ui-components/uds/index'
import { tk, Typography } from '@sunwebgroup/ui-components'
import * as React from 'react'
import { forwardRef } from 'react'
import { css, styled } from 'styled-components'

export const QuickSearchItem = styled.button<{ $isActive: boolean, $hasActiveSibling: boolean }>`
  cursor: pointer;
  margin-left: -1px;
  max-width: 200px;
  position: relative;
  height: 100%;
  flex: 1 1;
  min-width: 50px;
  @media ${tk('mq_desktop_md')} {
    max-width: 250px;
  }

  border-radius: ${tk('radius_rounded')};
  padding: 0 ${tk('spacing_lg')};
  text-align: left;
  width: 100%;

  &::before {
    content: '';
    display: block;
    height: 40px;
    width: 1px;
    background-color: ${tk('color_semantic_border')};
    position: absolute;
    left: 0;
    top: 0;
    transform: translateY(50%);
  }

  &:disabled {
    background-color: ${tk('color_semantic_bg_disabled')};
  }

  &:disabled:hover {
    background-color: ${tk('color_semantic_bg_disabled')};
  }

  &:hover {
    background-color: #e7e0d7;
  }

  &:first-of-type {
    padding-left: 20px;
    border-radius: 50px ${tk('radius_medium')} ${tk('radius_medium')} 50px;
  }

  &:last-of-type {
    margin-right: 8px;
    border-radius: ${tk('radius_medium')} 50px 50px ${tk('radius_medium')};
  }

  ${({ $isActive, $hasActiveSibling }) => !$isActive && !$hasActiveSibling && hoverMod()}
  ${({ $isActive, $hasActiveSibling }) => !$isActive && $hasActiveSibling && activeSiblingHoverMod()}
  ${({ $isActive }) => $isActive && isActiveMod()}
`
export const SelectionTextWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`
const SelectionText = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

function hoverMod() {
  return css`
  &:hover {
    background-color: ${tk('color_semantic_bg')};
    z-index: 1;

    &::before {
      content: initial;
    }
  }

`
}

function activeSiblingHoverMod() {
  return css`
  &:hover {
    background-color: ${tk('color_semantic_bg_strong')};

    &::before {
      content: initial;
    }
  }
`
}

function isActiveMod() {
  return css`
  background-color: ${tk('color_semantic_bg_subdued_hover')};
  z-index: 1;

    border-radius: ${tk('spacing_2xl')};
    background-color: ${tk('color_semantic_bg')};
    box-shadow: ${tk('shadow_md_bottom')};

  &::before {
    content: initial;
  }

  &:after {
    display: none;
  }
`
}

export const PlaceholderText = styled(SelectionText)`
  color: ${tk('color_semantic_text_subdued')};
`

export interface ItemProps {
  icon: IconGlyph
  title: string
  isActive: boolean
  hasActiveSibling: boolean
  placeholder?: string
  counter?: number
}

export const Item = forwardRef<HTMLButtonElement, ItemProps>((props, ref) => {
  const { title, placeholder, counter, isActive, hasActiveSibling } = props

  return (
    <QuickSearchItem $isActive={isActive} $hasActiveSibling={hasActiveSibling} {...props} ref={ref}>
      <Typography $variant="body-md-bold" as="p">
        {title}
      </Typography>
      <SelectionTextWrapper>

        <PlaceholderText $variant="body-md" as="p">
          {placeholder}
        </PlaceholderText>

        {counter && counter > 0
          ? (
              <Typography $variant="body-md" as="p">
                {`+${counter}`}
              </Typography>
            )
          : null}
      </SelectionTextWrapper>
    </QuickSearchItem>
  )
})
